import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Offering } from "@/lib/types/database/offerings";
import { offeringDetailActions } from "../config/offerings-actions";
import { offeringDetailBreadcrumbs } from "../config/offerings-detail-breadcrumbs";
import { offeringDetailTabs } from "../config/offerings-detail-tabs";
import {
  offeringTitleTemplate,
  offeringDescriptionTemplate,
} from "../config/offerings-detail-templates";

export const ENHANCED_OFFERING_DETAIL_CONFIG: DetailPageConfig<Offering> = {
  entity: "offerings",
  displayName: "Offering",
  tabs: offeringDetailTabs,
  actions: offeringDetailActions,
  detailActions: offeringDetailActions,
  breadcrumbs: offeringDetailBreadcrumbs,
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,
  titleTemplate: offeringTitleTemplate,
  descriptionTemplate: offeringDescriptionTemplate,
};
